import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAppDisplayModeContext } from '@archipro-design/aria';

import ContactPageMobile from '../component/contact-tab/ContactPage.mobile';
import ContactPageDesktop from '../component/contact-tab/ContactPage.desktop';
import type { APHandle } from '~/modules/root';
import { useProfessionalInitialRouteData } from '../hook/use-professional-initial-route-data';
import { useExpandAddressReveal } from '../hook/use-expand-address-reveal';

const ContactPage = () => {
    const { desktop } = useAppDisplayModeContext();
    const location = useLocation();
    const professional = useProfessionalInitialRouteData();

    useExpandAddressReveal();

    // For some reason, Remix scroll restoration brings page back to the top
    // on suppliers detail pages. This is here to ensure the page scrolls to the
    // contact section anchor after it has loaded.
    useEffect(() => {
        if (location.hash && professional) {
            // Remove the # from the hash to get the element ID
            const elementId = location.hash.substring(1);

            // Use requestAnimationFrame to ensure we run after all other scroll operations
            // Then add a delay to ensure Remix scroll restoration has completed
            requestAnimationFrame(() => {
                setTimeout(() => {
                    const element = document.getElementById(elementId);
                    if (element) {
                        element.scrollIntoView();
                    }
                }, 500); // Increased delay to ensure Remix has finished
            });
        }
    }, [location.hash, professional]);

    return !desktop ? <ContactPageMobile /> : <ContactPageDesktop />;
};

export const handle: APHandle = {
    disableTopNavAnimation: true,
    disableMobileUserScaling: true,
    hideContactArchiPro: true,
};

export default ContactPage;
